import React, { useEffect, useMemo } from "react";
import ReactECharts, { EChartsOption } from "echarts-for-react";
import { useLazyQuery } from "@apollo/client";
import { DashboardVars, GetDashboardJunctionCountData } from "../../types";
import { GetDashboardJunctionCount } from "../../queries";
import useUrlParams from "../../../../../../../customHooks/useUrlParams";

import useLoggedInUserDetails from "../../../../../../../customHooks/useLoggedInUserDetails";
import { colorsInGraph } from "../../../../../../../utils/UtilFunctions";
import { Title } from "../../../../../../../stories/Title/Title";
import { TEXT_FONT_FAMILY } from "../../../../../../../styles/Variables";

const TrafficSignalsChart = () => {
  const { customer_id } = useUrlParams();

  const { user_details } = useLoggedInUserDetails();
  const [GetDashboardItems, { data }] = useLazyQuery<
    GetDashboardJunctionCountData,
    DashboardVars
  >(GetDashboardJunctionCount);
  useEffect(() => {
    if (customer_id || user_details.id) {
      GetDashboardItems({
        variables: {
          customerID: customer_id ? customer_id : 0,
          empID: user_details.id ? user_details.id : 0,
        },
      });
    }
  }, [customer_id, user_details.id, GetDashboardItems]);

  const getRandomColor = () => {
    return colorsInGraph[Math.floor(Math.random() * colorsInGraph.length)];
  };
  const transformDataForSunburst = useMemo(() => {
    if (!data?.GetDashboardJunctionCount?.detailedChart) return [];

    return data.GetDashboardJunctionCount.detailedChart.map((signal) => ({
      name: `${signal.jType} (${signal.count})`,
      itemStyle: { color: getRandomColor() },
      children: (signal.vendorWiseData || []).map((vendor) => ({
        name: `${vendor.vendorName} (${vendor.total})`,
        itemStyle: { color: getRandomColor() },
        children: [
          // {
          //   name: `Total (${vendor.total})`,
          //   value: vendor.total,
          //   itemStyle: { color: "#2196F3" }
          // },
          {
            name: `Working (${vendor.WorkingData.working})`,
            value: vendor.WorkingData.working,
            itemStyle: { color: "#4CAF50" },
          },
          {
            name: `Tickets Raised (${vendor.WorkingData.notWorking})`,
            value: vendor.WorkingData.notWorking,
            itemStyle: { color: "#F44336" },
          },
        ],
      })),
    }));
  }, [data]);

  const option: EChartsOption = {
    series: {
      type: "sunburst",
      radius: [0, "95%"],
      sort: undefined,
      data: transformDataForSunburst,
      emphasis: {
        focus: "ancestor",
      },
      levels: [
        {},
        {
          r0: "15%",
          r: "35%",
          itemStyle: {
            borderWidth: 2,
          },
          label: {
            rotate: "radial",
            fontSize: 11,
            color: "#525252",
            fontFamily: TEXT_FONT_FAMILY,
            fontWeight: 400,
          },
        },
        {
          r0: "35%",
          r: "68%",
          label: {
            align: "center",
            rotate: "tangential",
            fontSize: 12,
            color: "#525252",
            fontFamily: TEXT_FONT_FAMILY,
            fontWeight: 400,
          },
        },
        {
          r0: "70%",
          r: "72%",
          label: {
            position: "outside",
            padding: 3,
            silent: false,
            fontSize: 12,
            fontFamily: TEXT_FONT_FAMILY,
            fontWeight: 700,
          },
          itemStyle: {
            borderWidth: 3,
          },
        },
      ],
    },
  };

  return (
    <div className="d-signal-details__detailed-graph">
      <ReactECharts option={option} />
    </div>
  );
};

export default TrafficSignalsChart;
